import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const RecordIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Record",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M20.5 15.5v-9C20.5 4.01 18.48 2 16 2s-4.5 2.02-4.5 4.5v9c0 2.49 2.02 4.5 4.5 4.5s4.5-2.02 4.5-4.5M8 12.11c-.83 0-1.5.67-1.5 1.5v1.78c.01 4.71 3.45 8.61 7.95 9.35h.06v2.25h-4.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h12c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-4.5v-2.25c4.56-.75 7.99-4.66 8-9.37V13.6c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v1.78c-.14 3.48-3 6.25-6.5 6.25s-6.36-2.77-6.5-6.24V13.6c0-.83-.67-1.5-1.5-1.5Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M16.14 23.86c-5.67 0-10.29-4.61-10.29-10.29a1.14 1.14 0 1 1 2.28 0c0 4.41 3.59 8 8 8s8-3.59 8-8a1.14 1.14 0 1 1 2.28 0c0 5.67-4.61 10.29-10.29 10.29Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M16.14 19.29c-3.15 0-5.71-2.56-5.71-5.71V5.57c0-3.15 2.56-5.71 5.71-5.71s5.71 2.56 5.71 5.71v8c0 3.15-2.56 5.71-5.71 5.71Zm0-17.15c-1.89 0-3.43 1.54-3.43 3.43v8c0 1.89 1.54 3.43 3.43 3.43s3.43-1.54 3.43-3.43v-8c0-1.89-1.54-3.43-3.43-3.43M21.86 31.86h-5.71c-.63 0-1.14-.51-1.14-1.14v-8a1.14 1.14 0 1 1 2.28 0v6.86h4.57a1.14 1.14 0 1 1 0 2.28"
      }), /*#__PURE__*/_jsx("path", {
        d: "M16.14 31.86h-5.71a1.14 1.14 0 1 1 0-2.28h5.71a1.14 1.14 0 1 1 0 2.28"
      })]
    })
  }));
};
RecordIcon.displayName = 'RecordIcon';